'use client'

import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {hover, text, white} from '@/styles/globalStyleVars';
import parser from "html-react-parser";
import {usePathname} from "next/navigation";

const MyComponent = ({
                         borderColor,
                         svg,
                         height,width,
                         background
                     }) => {
    const [isProjectPage, setIsProjectPage] = useState(false);
    const [isLandowner, setIsLandowner] = useState(false);

    const location=usePathname();

    useEffect(() => {

        if(location?.pathname==='/projects') {
            setIsProjectPage(true)
        }
        else setIsProjectPage(false)
        const currentPath = window.location.pathname;
        if (currentPath.includes("/media-center/")) {
            setIsLandowner(true)
        }
        else  setIsLandowner(false)

    }, [location?.pathname]);

    return (
        <StyledComponent
            borderColor={borderColor}
            height={height}
            width={width}
            background={background } isProjectPage={isProjectPage} isLandowner={isLandowner}
        >
             <span className='circle hover'>
                 {svg && typeof svg === 'string' && parser(svg)}
             </span>
        </StyledComponent>
    );
};

const StyledComponent = styled.div`

  .circle {
    height: ${p => p.height || 40}px;
    width: ${p => p.width || 40}px;
    border-radius: 50%;
    border: 1px solid ${p => p.isProjectPage || p.isLandowner ? `${text}` : (p.borderColor || `${text}`)};

    // border: 1px solid ${p => p.borderColor || `${text}`};
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover{
      border: 1px solid transparent;
      svg{
        path{
          stroke: ${p => p.isProjectPage || p.isLandowner ? `${white}`: ''};
        }
      }
    }
  }
  .hover {
    position: relative;
    overflow: hidden;

    .path {
      transition: fill 0.5s ease, stroke 0.5s ease;
    }

    &:after {
      content: '';
      position: absolute;
      height: 0;
      width: 0;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      background-color: ${p => p.background || `${hover}`};
      transition: all 0.5s ease;
      border-radius: 19px;
    }

    &:hover {

      .circle{
        border: 1px solid transparent;
      }
      .path {
        fill: white;
        stroke: transparent;
      }

      &:after {
        height: 100%;
        width: 100%;
      }
    }
  }
`;
// Pass a svg with a classname in the path named class="path";

export default MyComponent;
